<!--
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-12-11 18:18:56
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-13 11:33:25
 -->
<template>
  <div>
    <ActNav v-if="showActNav"></ActNav>
    <keep-alive>
      <router-view v-if="showActNav" />
    </keep-alive>
  </div>
</template>

<script>
import ActNav from "@/components/ActNav";

export default {
  components: {
    ActNav
  },
  computed: {
    showActNav() {
      return this.$store.state.Home.menuList.length;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/news.vue